var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31941_28457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4626 3.57618C26.1589 2.34683 25.2641 1.37877 24.1275 1.05022C22.0682 0.453125 13.8095 0.453125 13.8095 0.453125C13.8095 0.453125 5.55082 0.453125 3.49129 1.05022C2.35491 1.37877 1.45997 2.34683 1.15625 3.57618C0.604492 5.80425 0.604492 10.4531 0.604492 10.4531C0.604492 10.4531 0.604492 15.1018 1.15625 17.3302C1.45997 18.5594 2.35491 19.5275 3.49129 19.8562C5.55082 20.4531 13.8095 20.4531 13.8095 20.4531C13.8095 20.4531 22.0682 20.4531 24.1275 19.8562C25.2641 19.5275 26.1589 18.5594 26.4626 17.3302C27.0145 15.1018 27.0145 10.4531 27.0145 10.4531C27.0145 10.4531 27.0145 5.80425 26.4626 3.57618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1084 14.6682L18.011 10.4475L11.1084 6.22656V14.6682Z",
    fill: "#C6CBD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31941_28457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.41,
    height: 20,
    fill: "white",
    transform: "translate(0.604492 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube_white.e5c537527ac77f88766f8d88a23dd436.svg";
export { ForwardRef as ReactComponent };